<nz-date-picker [nzStatus]="status" [(ngModel)]="value" [nzDisabled]="disabled" [nzAllowClear]="allowClear"
              class="w-full rounded-lg h-10"  [nzPlaceHolder]="placeholder" [nzMode]="mode" [nzFormat]="format" ></nz-date-picker>
